import React from "react";
import "./aboutinnov.css";

function AboutInnov() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <header className="hero">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>About InforInnov</h1>
            <p>
              Empowering communities through digital literacy, mobile
              libraries, information services, and cultural preservation.
            </p>
          </div>
        </div>
      </header>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <h2>Who We Are</h2>

          <p>
            InforInnov is dedicated to bridging information gaps and creating
            opportunities through innovative learning and information access
            solutions.
          </p>

          <p>
            We believe that every individual deserves access to quality
            information, educational resources, and digital skills that empower
            them to thrive in a modern world.
          </p>

          <p>
            Through our programs and partnerships, we provide sustainable
            solutions that support learning, cultural preservation, and
            community development.
          </p>

          <p>
            Our commitment is to inspire lifelong learning while fostering
            inclusion and equal access to information resources.
          </p>
        </div>
      </section>

      {/* Achievement Section */}
      <section className="achievement-section">
        <div className="container">
          <h3>Our Achievement</h3>
          <p>
            We have impacted thousands of learners and community members by
            improving access to information, technology, and educational
            resources.
          </p>
        </div>
      </section>

      {/* Services */}
      <section className="services-section">
        <div className="container">
          <h2>Our Services</h2>

          <div className="services-grid">
            <div className="service-card">
              <img
                src="https://optimize.sirv.com/inforinnvo/2026%20Spelling%20Bee-399.webp"
                alt="Digital Literacy"
              />
              <div className="card-content">
                <h3>Digital Literacy</h3>
                <p>
                  Training programs that equip learners and communities with
                  essential digital skills.
                </p>
              </div>
            </div>

            <div className="service-card">
              <img
                src="https://optimize.sirv.com/inforinnvo/EduStem%20Fest%20Spelling%20Bee-28.webp"
                alt="Mobile Library"
              />
              <div className="card-content">
                <h3>Mobile Library</h3>
                <p>
                  Bringing books and educational resources closer to
                  underserved communities.
                </p>
              </div>
            </div>

            <div className="service-card">
              <img
                src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3"
                alt="Information Services"
              />
              <div className="card-content">
                <h3>Information Services</h3>
                <p>
                  Providing reliable information resources and support for
                  research and learning.
                </p>
              </div>
            </div>

            <div className="service-card">
              <img
                src="https://optimize.sirv.com/inforinnvo/spel1.webp"
                alt="Culture and Heritage"
              />
              <div className="card-content">
                <h3>Culture & Heritage</h3>
                <p>
                  Preserving and promoting cultural knowledge, traditions, and
                  heritage resources.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className="vision-section">
        <div className="container">
          <h3>Our Vision</h3>
          <p>
            To become a leading force in creating informed, digitally empowered,
            and culturally enriched communities through innovative information
            services.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>© 2026 InforInnov. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default AboutInnov;